export default __webpack_public_path__ + "static/media/why-5.b841d875.png";